import english from './english';
import hindi from './hindi';
import bengali from './bengali';
import tamil from './tamil';
import telugu from './telugu';
import marathi from './marathi';
import kannada from './kannada';
import malayalam from './malayalam';
import gujarati from './gujarati';
import punjabi from './punjabi';

export const translations = {
  english,
  hindi,
  bengali,
  tamil,
  telugu,
  marathi,
  kannada,
  malayalam,
  gujarati,
  punjabi
};

export const languages = [
  { code: 'english', name: 'English', nativeName: 'English' },
  { code: 'hindi', name: 'Hindi', nativeName: 'हिन्दी' },
  { code: 'bengali', name: 'Bengali', nativeName: 'বাংলা' },
  { code: 'tamil', name: 'Tamil', nativeName: 'தமிழ்' },
  { code: 'telugu', name: 'Telugu', nativeName: 'తెలుగు' },
  { code: 'marathi', name: 'Marathi', nativeName: 'मराठी' },
  { code: 'kannada', name: 'Kannada', nativeName: 'ಕನ್ನಡ' },
  { code: 'malayalam', name: 'Malayalam', nativeName: 'മലയാളം' },
  { code: 'gujarati', name: 'Gujarati', nativeName: 'ગુજરાતી' },
  { code: 'punjabi', name: 'Punjabi', nativeName: 'ਪੰਜਾਬੀ' }
]; 